import Review from "../models/IReview";

export default class ReviewService {
  getReviews = async (limit = 5, offset = 0): Promise<{ reviews: Review[]; hasMore: boolean }> => {
    const response = await fetch(
      `${process.env.REACT_APP_BASE_API_URL}/api/reviews?limit=${limit}&offset=${offset}`
    );
    return await response.json();
  };

 addReview = async (review: {userName: string;userEmailAddress?: string;comment?: string;rating: number;}): Promise<{ success: boolean; reviewId: number }> => {
    const response = await fetch(
        `${process.env.REACT_APP_BASE_API_URL}/api/reviews`,
        {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify(review),
        }
    );

    return await response.json();  
 };

getUnapprovedReviews = async (): Promise<Review[]> => {
    const response = await fetch(`${process.env.REACT_APP_BASE_API_URL}/api/reviews/unapproved`);
    return await response.json();
}

approveReview = async (id: number): Promise<{ success: boolean }> => {
    const response = await fetch(
      `${process.env.REACT_APP_BASE_API_URL}/api/reviews/${id}/approve`,
      { method: "PUT" }
    );
    return await response.json();
}

}